"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.lineClampStyles = void 0;
/**
 * Styles for truncating text to given count of lines.
 * The webkit-prefixed property names are needed for Firefox.
 * @param linesCount Maximal count of lines of text which should remain visible.
 * @returns Styles which can be further extended as needed.
 */ const lineClampStyles = (linesCount)=>({
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitBoxOrient: 'vertical',
        boxOrient: 'vertical',
        WebkitLineClamp: linesCount,
        lineClamp: linesCount
    });
exports.lineClampStyles = lineClampStyles;
